module.exports = __webpack_public_path__ + "34bc775d/img/send-icon.3cfb6275.svg";